import type {} from "@mui/x-data-grid/themeAugmentation";

import { createTheme } from "@mui/material/styles";

import defaultTheme from "./default";

const theme = createTheme(defaultTheme, {
    typography: {
        fontSize: 15,
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: "none",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fff86e",
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    color: "#000",
                },
            },
        },
    },
    palette: {
        background: {
            default: "#fff86e",
        },
        text: {
            primary: "#000",
        },
        primary: {
            main: "#000",
            contrastText: "#fff86e",
        },
        secondary: {
            main: "#fff86e",
            contrastText: "#000",
        },
    },
});

export default theme;
